module.exports = __webpack_public_path__ + "img/a123_1.b6030931.webp";